import { useState } from "react";
import Modal from "../shared/Modal";
import { useSelector, useDispatch } from "react-redux";
import {
  apiCreateWorkspaceForUser,
  apiGetWorkspace,
  apiSetCurrentWorkspace,
} from "../../services/WorkspaceService";
import {
  selectUser,
  setUser,
} from "../../redux/features/appData";
import "./ModalAddWorkspace.css";
import { useCoreDataLoader } from "../../hooks/useCoreDataLoader";

type ModalAddWorkspaceProps = {
  isOpen: boolean;
  onClose: any;
  onSuccess: any;
};

export default function ModalAddWorkspace({
  isOpen = false,
  onClose,
  onSuccess,
}: ModalAddWorkspaceProps) {
  const dispatch = useDispatch();
  const { reloadAll } = useCoreDataLoader();
  const [newWorkspaceName, setNewWorkspaceName] = useState("");
  const [newWorkspaceError, setNewWorkspaceError] = useState("");

  const storeUser = useSelector(selectUser);

  const saveNewWorkspace = async () => {
    if (!storeUser) {
      return;
    }

    const workspace = await apiCreateWorkspaceForUser(
      newWorkspaceName,
      storeUser.id
    );

    if (workspace) {
      const updatedWorkspace = await apiGetWorkspace(workspace.id);

      if (!updatedWorkspace) {
        setNewWorkspaceError("Error creating workspace");
        return;
      }

      // add the new one to the current store user
      const newWorkspaces = [...storeUser.workspaces, updatedWorkspace];
      const newUser = {
        ...storeUser,
        workspaces: newWorkspaces,
        currentWorkspaceId: updatedWorkspace.id,
      };

      dispatch(setUser(newUser));
      reloadAll(updatedWorkspace.id);
      await apiSetCurrentWorkspace(storeUser.id, workspace.id);
    }

    onSuccess();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        onClose={onClose}
        style={{}}
        isOpen={isOpen}
        canClose={false}
        allowClickout={true}>
        <div className="add-workspace-container">
          
          <div className="modal-title">
            Create A New Workspace
          </div>
         
          <div className="add-workspace-input">
            <input
              type="text"
              autoFocus={true}
              placeholder="Name your workspace"
              value={newWorkspaceName}
              onChange={(e) => {
                setNewWorkspaceName(e.target.value);
              }}
              onKeyDown={(e: any) => {
                if (e.key === "Enter" && newWorkspaceName.length > 0) {
                  saveNewWorkspace();
                }
              }}
            />
            {newWorkspaceError && (
              <div style={{ color: "var(--text-color-error)" }}>
                {newWorkspaceError}
              </div>
            )}
          </div>
          {/* <div>
            You can change your name and customize your workspace logo at
            anytime in your workspace settings.
          </div> */}
          <div className="modal-buttons">
            <button
              type="button"
              onClick={onClose}
              className="button-cancel"
            >
              Cancel
            </button>
            <button
              type="button"
              className="button-save"
              disabled={newWorkspaceName?.length < 1}
              onClick={saveNewWorkspace}
            >
              Create
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
